var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconPaymentWallet = function SvgIconPaymentWallet(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B5C4",
    fillRule: "nonzero",
    stroke: "#B0B5C4",
    strokeWidth: 0.5,
    d: "M24.58 10.352h-.593v-3.57a2.647 2.647 0 0 0-2.644-2.644h-.548L20.8 2.81c0-.984-.799-1.783-1.783-1.783H3.167A2.168 2.168 0 0 0 1 3.164V20.685c0 .984.8 1.783 1.783 1.783h18.565a2.647 2.647 0 0 0 2.644-2.644v-3.576h.594c.769 0 1.394-.625 1.394-1.393v-3.11a1.403 1.403 0 0 0-1.4-1.393zM3.168 2.258h15.85c.303 0 .554.246.554.548l-.005 1.332H3.167A.938.938 0 0 1 2.23 3.2c0-.517.42-.942.937-.942zm19.59 17.561c0 .779-.635 1.414-1.414 1.414H2.778a.554.554 0 0 1-.554-.553V5.152c.287.138.605.215.943.215h18.176c.779 0 1.414.636 1.414 1.414v3.57h-4.196c-.768 0-1.393.626-1.393 1.394v3.11c0 .768.625 1.393 1.393 1.393h4.196v3.571zm1.988-4.964a.162.162 0 0 1-.164.164h-6.014a.162.162 0 0 1-.164-.164v-3.11c0-.087.071-.164.164-.164h6.014c.087 0 .164.072.164.164v3.11z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconPaymentWallet, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-payment-wallet.af6dc7de.svg";
export { ForwardRef as ReactComponent };